import {
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DispatcherClass;
function Dispatcher() {
  if (DispatcherClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'Dispatcher', VOID, VOID, VOID, [1]);
    DispatcherClass = $;
  }
  return DispatcherClass;
}
var DeletePartyCommandClass;
function DeletePartyCommand() {
  if (DeletePartyCommandClass === VOID) {
    class $ {
      constructor(partyId) {
        this.p2l_1 = partyId;
      }
      toString() {
        return 'DeletePartyCommand(partyId=' + this.p2l_1.toString() + ')';
      }
      hashCode() {
        return this.p2l_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DeletePartyCommand()))
          return false;
        if (!this.p2l_1.equals(other.p2l_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'DeletePartyCommand');
    DeletePartyCommandClass = $;
  }
  return DeletePartyCommandClass;
}
//region block: exports
export {
  Dispatcher as Dispatcher2jh9je6zwmtr7,
  DeletePartyCommand as DeletePartyCommand2v2dr9f1zd6bq,
};
//endregion

//# sourceMappingURL=DeletePartyCommand.mjs.map
